import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICE_BY_SLUG } from "../data/services";
import { Eyebrow, Reveal } from "../lib/ui";

const QUICK = [
  "koeberraadgivning",
  "prisforhandling",
  "tinglysning-af-skoede",
  "skilsmisseskoede",
  "stiftelse-af-aps",
  "ejerftale",
  "testamente",
  "samejeoverenskomst",
  "fremtidsfuldmagt",
];

export const AreaLinks = () => {
  const navigate = useNavigate();
  const quick = QUICK.map((s) => SERVICE_BY_SLUG[s]).filter(Boolean);

  return (
    <section className="border-t border-slate-200 py-16 sm:py-24">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>Ydelser</Eyebrow>
          <h2 className="mt-4 max-w-3xl text-4xl font-semibold tracking-[-0.02em] text-slate-900 sm:text-5xl">
            Hurtigere frem til det rigtige
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            Vælg en ydelse og læs, hvordan vi hjælper — eller fortæl os kort om din sag, så
            finder vi frem sammen.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {quick.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.06} className="h-full">
              <div
                role="link"
                tabIndex={0}
                data-testid={`quicklink-${p.slug}`}
                onClick={() => navigate(`/ydelser/${p.slug}`)}
                onKeyDown={(e) => e.key === "Enter" && navigate(`/ydelser/${p.slug}`)}
                className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-900/5"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt=""
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <p className="text-[11px] font-semibold tracking-[0.18em] text-brand-600">
                    {p.category.title}
                  </p>
                  <h3 className="mt-2 text-xl font-semibold tracking-tight text-slate-900">
                    {p.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600 line-clamp-3">
                    {p.short}
                  </p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600">
                    Læs mere
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex justify-center">
            <button
              data-testid="quicklink-all"
              onClick={() => navigate("/ydelser")}
              className="group inline-flex items-center gap-3 rounded-full bg-brand-950 py-3 pl-7 pr-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-900"
            >
              Se alle ydelser
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-950 transition-transform duration-200 group-hover:rotate-[-45deg]">
                <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.2} />
              </span>
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default AreaLinks;